import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../../../symbols';
import { format } from '@/@core/utils/string';
let NoticeCenterApi = class NoticeCenterApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        this.postNotificationScenesPagination = (params) => {
            const { sEcho, iDisplayStart, iDisplayLength, ...other } = params;
            return this.http.post({
                url: this.urls.postNotificationScenesPagination,
                params: {
                    sEcho,
                    iDisplayStart,
                    iDisplayLength,
                },
                data: other,
            });
        };
        this.postNotificationScenes = (params) => {
            return this.http.post({
                url: this.urls.postNotificationScenes,
                data: params,
            });
        };
        this.putNotificationScenes = (params) => {
            return this.http.put({
                url: this.urls.putNotificationScenes,
                data: params,
            });
        };
        this.getNotificationScenes = (id) => {
            const url = format(this.urls.getNotificationScenes, { id });
            return this.http.get({
                url,
            });
        };
        this.postNotificationUserMessagePagination = (params) => {
            const { sEcho, iDisplayStart, iDisplayLength, ...other } = params;
            return this.http.post({
                url: this.urls.postNotificationUserMessagePagination,
                params: {
                    sEcho,
                    iDisplayStart,
                    iDisplayLength,
                },
                data: other,
            });
        };
        this.getNotificationSceneTypes = () => {
            return this.http.get({
                url: this.urls.getNotificationSceneTypes,
            });
        };
        this.postNotificationSceneTypes = (data) => {
            return this.http.post({
                url: this.urls.postNotificationSceneTypes,
                data,
            });
        };
        this.putNotificationSceneTypes = (data) => {
            return this.http.put({
                url: this.urls.putNotificationSceneTypes,
                data,
            });
        };
    }
};
NoticeCenterApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.NoticeCenterUrls)),
    __metadata("design:paramtypes", [Object, Object])
], NoticeCenterApi);
export { NoticeCenterApi };
